import Button from "@components/Button/Button";
import { ActionType } from "@components/Button/utlis/types";
import IconImg from "@components/Icon/IconImg";
import { IconTypeEnum } from "@components/Icon/types";
import { ArticleAllToolPopoverProps } from "@features/toolbar/ArticleToolbar/utils/types";
import useSendDataForTracking from "@hooks/useSendDataForTracking";
import { cn } from "@util/helpers";

export default function ArticleAppBannerButton({
  handleOpenModal,
  text,
  icon = IconTypeEnum.playLine,
  className,
  testId,
  trackingObject,
}: ArticleAllToolPopoverProps): React.ReactElement {
  const { sendTrackingData } = useSendDataForTracking();

  const handleOnClick = () => {
    if (handleOpenModal) handleOpenModal();

    if (!trackingObject) return;

    if (typeof window === "undefined") return;

    if (trackingObject?.eventLabel === undefined) {
      trackingObject.eventLabel = window.location.href;
    }

    sendTrackingData(trackingObject);
  };

  return (
    <Button
      actionType={ActionType.actionButton}
      className={cn("gap-1", { "aspect-square px-0": !text }, className)}
      onClick={handleOnClick}
      testId={testId}
    >
      <IconImg icon={icon} iconSize={24} imgAlt="play icon" />

      {text ? <p>{text}</p> : null}
    </Button>
  );
}
